import { createAuthApi } from "@yk/frontend-core";

/** Product-agnostic auth API for the unified shell (no product filter). */
export const authApi = createAuthApi({ product: null });
